/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, TabItem, Tabs } from 'bold-ui'

interface PoloBaseTab {
  id: ID
  nome: string
}

interface VisualizacaoTerritorialMicroareaTabsProps {
  microareas: string[]
  poloBase: PoloBaseTab
  currentMicroareaTab: string
  onTabClick: (microarea: string) => void
}

export default function VisualizacaoTerritorialMicroareaTabs(props: VisualizacaoTerritorialMicroareaTabsProps) {
  const { currentMicroareaTab, microareas, poloBase, onTabClick } = props

  return (
    <Grid
      style={css`
        margin-bottom: 0.25rem;
      `}
    >
      <Cell
        size={12}
        style={css`
          overflow-x: auto;
        `}
      >
        <Tabs>
          {poloBase && (
            <TabItem
              onClick={() => onTabClick(poloBase.id)}
              key={poloBase.id}
              active={poloBase.id === currentMicroareaTab}
            >
              {poloBase.nome.titleCase()}
            </TabItem>
          )}
          {microareas.map((microarea) => (
            <TabItem onClick={() => onTabClick(microarea)} key={microarea} active={microarea === currentMicroareaTab}>
              {microarea === 'FA'
                ? 'Fora de área'
                : microarea === currentMicroareaTab
                ? `Microárea ${microarea}`
                : microarea}
            </TabItem>
          ))}
        </Tabs>
      </Cell>
    </Grid>
  )
}
